export const grabAndGo = {
	activeProducts: "Produtos ativos para Grab and Go",
	disabledProducts: "Produtos desativados para Grab and Go",
	searchPlaceholder: "Filtrar produtos",
};
